import { fetchSummaryStatistics } from '../api';
import { Env } from '@/shared/config/environment';

const statisticAttributeMap = {
  amount: 'total_amount',
  count: 'order_count',
  earnings: 'total_earnings',
  prolong: 'orders_to_prolong',
};

const state = {
  summaryStatistics: null,
  isLoadingSummary: false,
  summaryError: null,
};

const mutations = {
  SET_SUMMARY_STATISTICS(state, stats) {
    state.summaryStatistics = stats;
  },
  SET_LOADING_SUMMARY(state, isLoading) {
    state.isLoadingSummary = isLoading;
  },
  SET_SUMMARY_ERROR(state, error) {
    state.summaryError = error;
  },
};

const actions = {
  async fetchSummaryStatistics({ commit, dispatch }) {
    commit('SET_LOADING_SUMMARY', true);
    commit('SET_SUMMARY_ERROR', null);
    commit('SET_SUMMARY_STATISTICS', null);

    try {
      const stats = await fetchSummaryStatistics();
      commit('SET_SUMMARY_STATISTICS', stats);

      return stats;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося отримати статистику продажів';

      commit('SET_SUMMARY_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося отримати поточну статистику продажів',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_SUMMARY', false);
    }
  },
};

const getters = {
  summaryStatistics: (state) => state.summaryStatistics,
  isLoadingSummary: (state) => state.isLoadingSummary,
  summaryError: (state) => state.summaryError,

  isSummaryDataReady: (state) => { return state.isLoadingSummary === false && state.summaryStatistics !== null; },
  getSummaryStatistics: (state) => state.summaryStatistics,
  getStatisticValue: (state) => (type, period) => { return state.summaryStatistics?.[period]?.[statisticAttributeMap[type]] || 0; },
  getCurrentMonthValue: (state) => (type) => { return state.summaryStatistics?.month?.[statisticAttributeMap[type]] || 0; },
  getStatisticValueTrend: (state) => (type, period) => { return state.summaryStatistics?.trends?.[period]?.[statisticAttributeMap[type]] || 0; },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
